// client/src/components/admin/project/ResultUrlEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ResultUrlEditModal({ open, onClose, result, onSaved }) {
  const [urls, setUrls] = useState(['']);
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && result) {
      setUrls(result.resultUrls && result.resultUrls.length > 0 ? [...result.resultUrls] : ['']);
      setNote(result.resultNote || '');
    }
  }, [open, result]);

  const handleAddUrl = () => {
    if (urls.length < 100) {
      setUrls([...urls, '']);
    }
  };

  const handleRemoveUrl = (index) => {
    if (urls.length > 1) {
      setUrls(urls.filter((_, i) => i !== index));
    }
  };

  const handleUrlChange = (index, value) => {
    const newUrls = [...urls];
    newUrls[index] = value;
    setUrls(newUrls);
  };

  const handleSave = async () => {
    // 빈 URL 제거
    const filteredUrls = urls.filter(url => url && url.trim());
    
    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/results/${result.id}/urls`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          resultUrls: filteredUrls,
          resultNote: note
        })
      });

      const data = await res.json();

      if (data.ok) {
        alert(data.message || 'URL이 저장되었습니다.');
        onSaved && onSaved();
        onClose();
      } else {
        alert(data.message || 'URL 저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('URL 저장 오류:', error);
      alert('URL 저장 중 오류가 발생했습니다.');
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <div className="result-url-edit-modal">
      <div className="result-url-edit-modal__content" onClick={(e) => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="result-url-edit-modal__header">
          <div>
            <h2 className="result-url-edit-modal__title">결과물 URL 수정</h2>
            <div className="result-url-edit-modal__subtitle">
              인플루언서: <strong>{result?.influencerName}</strong> ({result?.influencerUserId})
            </div>
            <div className="result-url-edit-modal__subtitle" style={{ marginTop: 4 }}>
              현재 상태: {getStatusText(result?.resultStatus)}
            </div>
          </div>
        </div>

        {/* 본문 */}
        <div className="result-url-edit-modal__body">
          {/* URL 목록 */}
          <div className="result-url-edit-modal__form-group">
            <label className="result-url-edit-modal__label">
              📎 결과물 URL
            </label>
            
            {urls.map((url, index) => (
              <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input
                  type="url"
                  value={url}
                  onChange={(e) => handleUrlChange(index, e.target.value)}
                  placeholder="https://..."
                  className="result-url-edit-modal__input"
                />
                {urls.length > 1 && (
                  <button
                    onClick={() => handleRemoveUrl(index)}
                    style={{
                      padding: '8px 12px',
                      background: '#ef4444',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      cursor: 'pointer',
                      fontSize: 14,
                      fontWeight: 600
                    }}
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}

            {urls.length < 100 && (
              <button
                onClick={handleAddUrl}
                style={{
                  padding: '8px 16px',
                  background: '#f3f4f6',
                  color: '#374151',
                  border: '1px dashed #d1d5db',
                  borderRadius: 6,
                  cursor: 'pointer',
                  fontSize: 13,
                  fontWeight: 600,
                  marginTop: 8
                }}
              >
                + URL 추가
              </button>
            )}
          </div>

          {/* 메모 */}
          <div className="result-url-edit-modal__form-group">
            <label className="result-url-edit-modal__label">
              💬 메모 (선택사항)
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="기타 사항이 있으면 입력해주세요"
              maxLength={2000}
              rows={4}
              className="result-url-edit-modal__input"
              style={{ resize: 'vertical' }}
            />
            <div className="result-url-edit-modal__hint">
              {note.length} / 2000
            </div>
          </div>

          {/* 안내 메시지 */}
          <div className="result-url-edit-modal__warning" style={{
            background: '#e0f2fe',
            border: '1px solid #7dd3fc',
            color: '#0c4a6e'
          }}>
            💡 URL과 메모만 수정됩니다. 결과물 상태는 변경되지 않습니다.
          </div>
        </div>

        {/* 푸터 */}
        <div className="result-url-edit-modal__footer">
          <button
            onClick={onClose}
            disabled={saving}
            className="result-url-edit-modal__button result-url-edit-modal__button--cancel"
            style={{ cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            취소
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className={`result-url-edit-modal__button result-url-edit-modal__button--submit ${
              saving ? '' : ''
            }`}
          >
            {saving ? '저장 중...' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
}

function getStatusText(status) {
  const statusMap = {
    'none': '제출 대기',
    'submitted': '승인 대기',
    'approved': '승인 완료',
    'rejected': '거절',
    'admin_reviewing': '셀프애드 팀 검토 중',
    'admin_approved': '셀프애드 팀 승인',
    'admin_rejected': '셀프애드 팀 거절',
    'expired': '기한 내 미제출'
  };
  return statusMap[status] || status;
}

